import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1d7c7ccc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1d7c7ccc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7c7ccc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d7c7ccc')) {
      api.createRecord('1d7c7ccc', component.options)
    } else {
      api.reload('1d7c7ccc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1d7c7ccc&scoped=true", function () {
      api.rerender('1d7c7ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CFailure/index.vue"
export default component.exports